//
//
//
//
//
//
//
//
//

import MenuList from "./MenuAside/MenuList";
export default {
  components: {
    MenuList
  },
  data() {
    return {
      navLinks: [
        {
          name: this.$t('profileMenu.profile'),
          link: '/profile/detail'
        },
        {
          name: this.$t('profileMenu.gallery'),
          link: `/profile/gallery`
        },
        {
          name: this.$t('profileMenu.settings'),
          link: '/profile/settings'
        },
        {
          name: this.$t('profileMenu.logout'),
          link: '/app/',
          action: 'deleteToken'
        }
      ]
    }
  }
}
